export default __webpack_public_path__ + "static/media/RouterImg.2fcc2d3a.jpg";